import {
  AfterViewInit,
  Component,
  ContentChildren,
  ElementRef,
  Input,
  QueryList,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MenuProps, menuStyles } from '@kite_aerolab/shared/components';
import { MenuItemComponent } from './menu-item.component';
import { getBreakpoint, getRandomID } from '@kite_aerolab/shared/utils';

@Component({
  selector: 'kite-menu',
  templateUrl: './menu.component.html',
})
export class MenuComponent implements AfterViewInit {
  items: HTMLElement[];
  selected = -1;

  breakpoint = getBreakpoint();

  @ViewChild('containerRef') containerRef: ElementRef;
  @ContentChildren(MenuItemComponent, { descendants: true }) list: QueryList<MenuItemComponent>;
  /*
   * css
   *
   * */
  @Input() css: MenuProps['css'];

  /*
   * id
   *
   * */
  @Input() id: MenuProps['id'] = getRandomID();

  /*
   * Handle click outside
   *
   * */
  constructor(private renderer: Renderer2) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.containerRef.nativeElement.contains(e.target)) {
        this.isOpen = false;
      }
    });
    // Actualiza el breakpoint
    this.renderer.listen('window', 'resize',() => {
      this.breakpoint = getBreakpoint();
    })
  }

  /*
   * Label del botón
   */
  _label: MenuProps['label'];

  @Input() get label() {
    return this._label;
  }

  set label(value: MenuProps['label']) {
    this._label = value;
  }

  /*
   * Alineación del botón
   */
  _align: MenuProps['align'];

  @Input() get align() {
    return this._align;
  }

  set align(value: MenuProps['align']) {
    if (value === 'center' && this.type === 'button') {
      this._align = 'left';
    } else {
      this._align = value;
    }
  }

  /*
   * Tipo de botón
   */
  _type: MenuProps['type'];

  @Input() get type() {
    return this._type;
  }

  set type(value: MenuProps['type']) {
    this._type = value;
  }

  /*
   * Visibilidad del desplegable
   */
  _isOpen: MenuProps['isOpen'];

  @Input() get isOpen() {
    return this._isOpen;
  }

  set isOpen(value: MenuProps['isOpen']) {
    this._isOpen = value;
  }

  public get menu(): string[] {
    return [
      menuStyles({
        isOpen: !!this.isOpen,
        type: this.type,
        align: this.align,
        css: this.css,
      }).className,
    ];
  }

  ngAfterViewInit() {
    this.items = this.list.map((item) => {
      return item.itemRef.nativeElement;
    });
    if (this.align === 'center' && this.type === 'button') {
      this.align = 'left';
    }
  }

  toggleOpen(event: Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    this.selected = -1;
    this.list.forEach((item) => {
      item.itemRef.nativeElement.classList.contains('focus') && item.itemRef.nativeElement.classList.remove('focus');
    });
  }

  myToggle() {
    this.isOpen = false;
  }

  handleKeyPress = (event: KeyboardEvent) => {
    this.isOpen = true;
    const items = this.items;
    if (event.key === 'ArrowDown') {
      if (this.selected === -1) {
        items[0].classList.add('focus');
        items[0].focus();
        this.selected = 0;
      } else {
        items[this.selected].classList.remove('focus');
        this.selected = this.selected >= items.length - 1 ? 0 : this.selected + 1;
        items[this.selected].classList.add('focus');
        items[this.selected].focus();
      }
    }
    if (event.key === 'ArrowUp') {
      if (this.selected === -1) {
        items[items.length - 1].classList.add('focus');
        items[items.length - 1].focus();
        this.selected = items.length - 1;
      } else {
        items[this.selected].classList.remove('focus');
        this.selected = this.selected === 0 ? items.length - 1 : this.selected - 1;
        items[this.selected].classList.add('focus');
        items[this.selected].focus();
      }
    }
    if (event.keyCode == 32 || event.keyCode == 13) {
      event.stopPropagation();
      if (!this.list.toArray()[this.selected].isCheckable) {
        this.list.toArray()[this.selected].containerRef.nativeElement.parentElement.click();
      } else {
        this.list.toArray()[this.selected].isChecked = !this.list.toArray()[this.selected].isChecked;
      }
    }
  };
}
